import React from 'react';

interface CalculationsIconProps {
    fill?: string;
}

export const CalculationsIcon = ({ fill = 'black' }: CalculationsIconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <g clipPath="url(#clip0_6001_51745)">
                <path
                    d="M10.6667 6.69133L12.9733 4H16V0H12V1.33333H4V0H0V4H1.33333V12H0V16H4V14.6667H12V16H16V12H12.9733L10.6667 9.30867V6.69133ZM9.33333 7.33333V8.66667H8V7.33333H9.33333ZM13.3333 1.33333H14.6667V2.66667H13.3333V1.33333ZM1.33333 1.33333H2.66667V2.66667H1.33333V1.33333ZM2.66667 14.6667H1.33333V13.3333H2.66667V14.6667ZM4 13.3333V12H2.66667V4H4V2.66667H12V3.08667L9.50267 6H6.66667V10H9.50267L12 12.9133V13.3333H4ZM13.3333 13.3333H14.6667V14.6667H13.3333V13.3333Z"
                    fill={fill}
                />
            </g>
            <defs>
                <clipPath id="clip0_6001_51745">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
